// Actions
export const LOGIN_USER = {
  request: () => 'LOGIN_USER_REQUEST',
  success: () => 'LOGIN_USER_SUCCESS',
  error: () => 'LOGIN_USER_ERROR'
};

export const FETCH_USER_INFO = {
  request: () => 'FETCH_USER_INFO_REQUEST',
  success: () => 'FETCH_USER_INFO_SUCCESS',
  error: () => 'FETCH_USER_INFO_ERROR'
};

export const FETCH_PROFILE = {
  request: () => 'FETCH_PROFILE_REQUEST',
  success: () => 'FETCH_PROFILE_SUCCESS',
  error: () => 'FETCH_PROFILE_ERROR'
};

export const FETCH_USER_LOCATION = {
  request: () => 'FETCH_USER_LOCATION_REQUEST',
  success: () => 'FETCH_USER_LOCATION_SUCCESS',
  error: () => 'FETCH_USER_LOCATION_ERROR'
};
